import { render, staticRenderFns } from "./SingleResult.vue?vue&type=template&id=734e8be5&"
import script from "./SingleResult.vue?vue&type=script&lang=js&"
export * from "./SingleResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports